var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SidbearSettingsGroup',{attrs:{"title":"Card Settings"}},[(_vm.linked)?_c('b-form-group',[_c('button',{staticClass:"flex p-0 text-[11px] hover:bg-gray-100 items-center text-dark border rounded-[4px] w-[114px] h-[30px] justify-content-center gap-[5px] cursor-pointer font-[500] hover:text-[#3D82EA] text-[#7E7E7E]",on:{"click":() => _vm.unlinkSid()}},[_vm._v(" Unlink Styles "),_c('i',{staticClass:"fa fa-link text-primary"})])]):_vm._e(),_c('b-form-group',[_c('b-checkbox',{attrs:{"switch":""},model:{value:(_vm.section.options.content.tableOfContents.sticky),callback:function ($$v) {_vm.$set(_vm.section.options.content.tableOfContents, "sticky", $$v)},expression:"section.options.content.tableOfContents.sticky"}},[_vm._v(" Sticky on Scroll ")])],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Overflow")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--card.toc-card`,"rule-name":"overflow","options":[{label: 'Hidden', value: 'hidden'}, {label: 'Visible', value: 'visible'}]}})],1)]),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--card.toc-card`}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--card.toc-card`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--card.toc-card`,"label":"Border Width","rule-name":"border","angles":[
          {
            text: '',
            value: 'top-width'
          },
          {
            text: '',
            value: 'right-width'
          },
          {
            text: '',
            value: 'bottom-width'
          },
          {
            text: '',
            value: 'left-width'
          }
        ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--card.toc-card`,"rule-name":"border-color"}})],1)],1),_c('b-form-group',[_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--card.toc-card`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
          {
            text: '',
            value: 'top-left-radius',
            cssVar: '--border-top-left-radius'
          },
          {
            text: '',
            value: 'top-right-radius',
            cssVar: '--border-top-right-radius'
          },
          {
            text: '',
            value: 'bottom-left-radius',
            cssVar: '--border-bottom-left-radius'
          },
          {
            text: '',
            value: 'bottom-right-radius',
            cssVar: '--border-bottom-right-radius'
          }
        ]}})],1),_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.section.sid}--card.toc-card`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.section.sid}--card.toc-card`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Shadow Color"}},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}--card.toc-card`,"rule-name":"box-shadow"}})],1)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Card Header"}},[_c('b-form-group',{attrs:{"label":"Title"}},[_c('b-input',{model:{value:(_vm.section.options.content.tableOfContents.title),callback:function ($$v) {_vm.$set(_vm.section.options.content.tableOfContents, "title", $$v)},expression:"section.options.content.tableOfContents.title"}})],1),_c('sid-font',{attrs:{"sid":`.--${_vm.section.sid}--card.toc-card .toc-title`}}),_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Text Size","sid":`.--${_vm.section.sid}--card.toc-card .toc-card--header`,"rule-name":"font-size"}})],1),_c('b-form-group',[_c('sid-align',{attrs:{"sid":`.--${_vm.section.sid}--card.toc-card .toc-card--header`,"rule-name":"text-align","label":"Text Alignment"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--card.toc-card .toc-card--header`,"rule-name":"color"}})],1)]),_c('b-form-group',[_c('b-checkbox',{attrs:{"switch":""},model:{value:(_vm.section.options.content.tableOfContents.toggler),callback:function ($$v) {_vm.$set(_vm.section.options.content.tableOfContents, "toggler", $$v)},expression:"section.options.content.tableOfContents.toggler"}},[_vm._v(" Show Toggle ")])],1),_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.section.sid}--card.toc-card .toc-card--header`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.section.sid}--card.toc-card .toc-card--header`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--card.toc-card .toc-card--header`}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--card.toc-card .toc-card--header`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--card.toc-card .toc-card--header`,"label":"Border Width","rule-name":"border","angles":[
          {
            text: '',
            value: 'top-width'
          },
          {
            text: '',
            value: 'right-width'
          },
          {
            text: '',
            value: 'bottom-width'
          },
          {
            text: '',
            value: 'left-width'
          }
        ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--card.toc-card .toc-card--header`,"rule-name":"border-color"}})],1)],1),_c('b-form-group',[_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--card.toc-card .toc-card--header`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
          {
            text: '',
            value: 'top-left-radius',
            cssVar: '--border-top-left-radius'
          },
          {
            text: '',
            value: 'top-right-radius',
            cssVar: '--border-top-right-radius'
          },
          {
            text: '',
            value: 'bottom-left-radius',
            cssVar: '--border-bottom-left-radius'
          },
          {
            text: '',
            value: 'bottom-right-radius',
            cssVar: '--border-bottom-right-radius'
          }
        ]}})],1),_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Shadow Color"}},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}--card.toc-card .toc-card--header`,"rule-name":"box-shadow"}})],1)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Card Body"}},[_c('b-form-group',{attrs:{"label":"Anchors"}},[_c('div',{staticClass:"sid-select"},[_c('div',{staticClass:"vs-tags"},[_c('v-select',{staticClass:"custom-select tag-select-popped",attrs:{"options":[
              { id: 'h1', name: 'H1' },
              { id: 'h2', name: 'H2' },
              { id: 'h3', name: 'H3' },
              { id: 'h4', name: 'H4' },
              { id: 'h5', name: 'H5' },
              { id: 'h6', name: 'H6' }
            ],"append-to-body":"","multiple":"","label":"name","reduce":val => val.id},model:{value:(_vm.section.options.content.tableOfContents.anchors),callback:function ($$v) {_vm.$set(_vm.section.options.content.tableOfContents, "anchors", $$v)},expression:"section.options.content.tableOfContents.anchors"}})],1)])]),_c('b-form-group',{attrs:{"label":"Exclude Anchors by ID"}},[_c('div',{staticClass:"sid-select"},[_c('div',{staticClass:"vs-tags"},[_c('v-select',{staticClass:"custom-select tag-select-popped",attrs:{"options":_vm.hIds,"append-to-body":"","multiple":""},model:{value:(_vm.section.options.content.tableOfContents.excludes),callback:function ($$v) {_vm.$set(_vm.section.options.content.tableOfContents, "excludes", $$v)},expression:"section.options.content.tableOfContents.excludes"}})],1)])]),_c('b-form-group',[_c('div',{staticClass:"flex justify-between items-center select-wrapper"},[_c('label',{staticClass:"pb-0"},[_vm._v(" Marker type ")]),_c('v-select',{staticClass:"!w-[100px] cusstom-select",attrs:{"options":[
            { id: 'number', name: 'Numbers' },
            { id: 'bullet', name: 'Bullets' },
            { id: 'icon', name: 'Icon' },
          ],"reduce":item => item.id,"label":"name","searchable":false},model:{value:(_vm.section.options.content.tableOfContents.marker),callback:function ($$v) {_vm.$set(_vm.section.options.content.tableOfContents, "marker", $$v)},expression:"section.options.content.tableOfContents.marker"}})],1)]),(_vm.section.options.content.tableOfContents.marker == 'icon')?[_c('b-form-group',[_c('icon-select',{model:{value:(_vm.section.options.content.tableOfContents.iconClass),callback:function ($$v) {_vm.$set(_vm.section.options.content.tableOfContents, "iconClass", $$v)},expression:"section.options.content.tableOfContents.iconClass"}})],1),_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Icon Size","sid":`.--${_vm.section.sid}--card.toc-card .toc-h-item-icon`,"rule-name":"font-size"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Icon Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--card.toc-card .toc-h-item-icon`,"rule-name":"color"}})],1)])]:_vm._e(),_c('hr'),_c('sid-font',{attrs:{"sid":`.--${_vm.section.sid}--card.toc-card .toc-h-item`}}),_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Text Size","sid":`.--${_vm.section.sid}--card.toc-card .toc-h-item`,"rule-name":"font-size"}})],1),_c('b-form-group',[_c('sid-align',{attrs:{"sid":`.--${_vm.section.sid}--card.toc-card .toc-card--body`,"rule-name":"text-align","label":"Text Alignment"}})],1),_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--card.toc-card .toc-h-item`,"rule-name":"color"}})],1)])]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--card.toc-card .toc-h-item`,"rule-name":"color","presudo":":hover","pseudo-index":1}})],1)])]},proxy:true}])}),_c('hr'),_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.section.sid}--card.toc-card .toc-card--body`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.section.sid}--card.toc-card .toc-card--body`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--card.toc-card .toc-card--body`}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--card.toc-card .toc-card--body`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--card.toc-card .toc-card--body`,"label":"Border Width","rule-name":"border","angles":[
          {
            text: '',
            value: 'top-width'
          },
          {
            text: '',
            value: 'right-width'
          },
          {
            text: '',
            value: 'bottom-width'
          },
          {
            text: '',
            value: 'left-width'
          }
        ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--card.toc-card .toc-card--body`,"rule-name":"border-color"}})],1)],1),_c('b-form-group',[_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--card.toc-card .toc-card--body`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
          {
            text: '',
            value: 'top-left-radius',
            cssVar: '--border-top-left-radius'
          },
          {
            text: '',
            value: 'top-right-radius',
            cssVar: '--border-top-right-radius'
          },
          {
            text: '',
            value: 'bottom-left-radius',
            cssVar: '--border-bottom-left-radius'
          },
          {
            text: '',
            value: 'bottom-right-radius',
            cssVar: '--border-bottom-right-radius'
          }
        ]}})],1),_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Shadow Color"}},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}--card.toc-card .toc-card--body`,"rule-name":"box-shadow"}})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }